export default __webpack_public_path__ + "1a53372a80726e85fa68fd4ea9feca1f.png";